<template>
  <div id="carrello">
    <ShopSlider></ShopSlider>
    <div class="row carrello">
      <div class="col-lg-6 col-sm-6 col-md-6 col-6">
        <router-link :to="{name: 'homepage'}">Home</router-link>
        /
        <router-link :to="{name: 'shop'}">Shop</router-link>
        / Carrello
      </div>
    </div>
    <div class="row riga"  v-bind:style="{'min-height': pageHeight/3 + 'px'}">
      <div class="categoria row">
        <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-3">Prodotto</div>
        <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-4">Prezzo</div>
        <div class="col-xl-1 col-lg-1 col-md-2 col-sm-2 col-3">Quantità</div>
        <div class="col-xl-3 col-lg-3 col-md-2 col-sm-2 col-2">Subtotale</div>
      </div>
      <li class="testoRiepilogo" v-for="(wine, index) in cart">
        <dettagliocarrello :wine="wine" :flag="flag" :qntyProd="qntyProd[wine.idProduct]"
                           @update="onUpdate"></dettagliocarrello>
      </li>
      <div class="subtoto">Totale:&nbsp;<div style="color: #ddc18f;" v-price v-if="totale !== 0">{{totale}}</div>
      </div>
    </div>
    <b-btn v-if="cartIsValid" class="botton" :to="{name: 'completaordine'}">Procedi con l'ordine</b-btn>
    <Footer></Footer>
  </div>
</template>

<script>
  import Dettagliocarrello from "./DettaglioCarrello"
  import ShopSlider from './ShopSlider'
  import Footer from './Footer'
  import Bus from './Bus'

  export default {
    name: "carrello",
    components: {Dettagliocarrello, ShopSlider, Footer},
    data() {
      return {
        pageHeight: window.innerHeight,
        cart: [],
        totale: 0,
        totProd: 0,
        flag: false, //serve per aggiornare il subtotale in dettaglio carrello, non toglierlo
        winesAvailability: [],
        qntyProd: []
      }
    },
    watch: {
      cart: function (){
        this.flag = true
      },
    },
    methods: {
      checkProductQnty: function () {
        this.$http.get('/ws-shop/order/checkProductQnty', {params: {idCarrello: localStorage.getItem('idCarrello')}}).then(response => {
          if (response.body.rc === 0) {
            this.qntyProd = []
            response.body.data.forEach(row => {
              if (row.qnty === false) {
                // console.log('Quantità di ' + row.idProduct + ' non disponibile')
                this.qntyProd[row.idProduct] = false
              } else {
                this.qntyProd[row.idProduct] = true
              }
            })
          }
          this.listCart()
        })
      },
      checkBoolean: function () {
        if (this.qntyProd.includes(false) || this.cart.length === 0) return false
        else return true
      },
      onUpdate: function () {
        this.flag = false
        this.checkProductQnty()
      },
      listCart: function () {
        this.totale = 0
        this.totProd = 0

        this.$http.get('/ws-shop/cart/', {params: {idCarrello: localStorage.getItem('idCarrello')}}).then(response => {
          this.cart = response.body.data
          this.totale = response.body.totale
          this.cart.forEach(row => {
            this.totProd += row.qntyOrd
          })
          Bus.$emit('totale', this.totProd)
        })
      }
    },
    mounted: function () {
      this.checkProductQnty()
    },
    computed: {
      cartIsValid: function () {
        if (this.qntyProd.includes(false) || this.cart.length === 0) return false
        else return true
      }
    }
  }
</script>

<style lang="less">
  @import "../assets/less/variabili.less";
  @import "../assets/less/font.less";

  #carrello {
    color: white;
    width: 100%;
    margin-left: 0px;
    background-color: #585353;
    li {
      list-style-type: none;
    }
    .row {
      margin-left: 0px;
      margin-right: 0px;
      padding: 20px;
      .set-font-latoLight();
      input[type=number] {
        text-align: center;
        font-weight: 700;
        outline: none;
      }
    }
    .detailcar {
      text-align: right;
      width: 15%;
      cursor: pointer;
      #car {
        position: relative;
        width: 45px;
        .set-font-latoLight();
      }
      .numprod {
        color: orange;
        position: absolute;
        right: 18px;
        top: -5px;
        font-weight: bold;
        width: 35px;
        text-align: center;
      }
    }
    .categoria {
      width: 80%;
      margin: auto;
      text-align: center;
      padding: 20px;
      border-bottom: 1px solid white;
      .set-font-title();
    }
    .testoRiepilogo {
      width: 80%;
      margin: auto;
      margin-top: 25px;
      letter-spacing: 1px;
      padding-right: 0px;
      padding-left: 0px;
      .set-font();
      #dettaglio {
        border: .5px;
        border-style: solid;
        text-align: center;
        background-color: @lightBlack;
        .righeRiepilogo {
          padding: 0px;
          .carlink {
            padding-left: 0px;
            padding-right: 0px;
            #imgVino {
              border-style: solid;
              border-width: 0px 0.5px 0px 0px;
              .vinello {
                width: 129px;
                margin: auto;
                padding: 15px;
              }
              .smartbox{
                width: 187px;
                margin: auto;
                padding: 15px;
              }
              .notVinello {
                width: 80px;
                margin: auto;
                padding: 15px;
                opacity: 0.4;
              }
              .notSmartbox {
                width: 187px;
                margin: auto;
                padding: 15px;
                opacity: 0.4;
              }
            }
          }
          .nomeVino {
            padding: 20px;
            margin: auto;
            .set-font-latoLight(@size: 30px);
          }
          .notAvailable {
            margin: auto;
            .set-font(@color: orange)
          }
          .quantity {
            padding: 20px;
            margin: auto;
            text-align: right;
            .set-font-latoRegular();
            .quantità {
              width: 30%;
              background-color: #585353;
              color: white;
              border-color: @darkGray;
            }
          }
          .price1 {
            padding: 20px;
            text-align: center;
            color: white;
            margin: auto;
            .set-font-latoRegular(@color: light-green);
          }
          .price {
            padding: 20px;
            text-align: right;
            color: @lightGold;
            margin: auto;
            .set-font-latoRegular(@color: light-green);
          }
          .remove {
            margin: auto;
            padding: 5px;
            .logo {
              cursor: pointer;
              width: 25px;
            }
          }
        }
      }
    }
    .subtoto {
      margin-left: 75%;
      margin-top: 50px;
      letter-spacing: 1px;
      display: flex;
      .set-font(@size: 22px, @weight: bold)
    }
    .botton {
      background-color: @myOrange;
      border-color: @borderOrange;
      text-align: center;
      letter-spacing: 1px;
      margin-left: 80%;
      margin-top: 50px;
      margin-bottom: 50px;
      .set-font()
    }
  }

  @media (max-width: 767px) {
    #carrello {
      .row {
        padding: 10px;
        .set-font-latoLight(@size: 14px);
      }
      .detailcar {
        padding-right: 8px;
        padding-left: 5px;
        #car {
          .set-font-latoLight();
        }
        .numprod {
          right: 10px;
        }
      }
      .categoria {
        width: 100%;
        .set-font-title(@size: 16px);
      }
      .testoRiepilogo {
        width: 100%;
        letter-spacing: 1px;
        .set-font();
        #dettaglio {
          .righeRiepilogo {
            .carlink {
              #imgVino {
                .vinello {
                  width: 43px;
                }
                .smartbox{
                  width: 100%;
                }
                .notVinello {
                  width: 43px;
                }
                .notSmartbox {
                  width: 100%;
                }
              }
            }
            .nomeVino {
              padding: 3px;
              .set-font-latoLight(@size: 16px);
            }
            .quantity {
              padding: 0px;
              .set-font-latoRegular(@size: 14px);
              .quantità {
              }
            }
            .price1 {
              padding: 0px;
              .set-font-latoRegular(@size: 14px; @color: light-green);
            }
            .price {
              padding: 0px;
              .set-font-latoRegular(@size: 14px; @color: light-green);
            }
            .remove {
              .logo {
                width: 15px;
              }
            }
          }
        }
      }
      .subtoto {
        margin-left: 55%;
        margin-top: 20px;
        .set-font(@size: 16px, @weight: bold)
      }
      .botton {
        margin-left: 45%;
        margin-top: 10px;
        margin-bottom: 20px;
        .set-font(@size: 13px)
      }
    }

  }

  @media (min-width: 768px) and (max-width: 1024px) {
    #carrello {
      .detailcar {
        #car {
          .set-font-latoLight();
        }
        .numprod {
        }
      }
      .categoria {
        width: 95%;
        .set-font-title(@size: 18px);
      }
      .testoRiepilogo {
        width: 95%;
        .set-font();
        #dettaglio {
          .righeRiepilogo {
            .carlink {
              #imgVino {
                .vinello {
                  width: 60%;
                }
                .smartbox{
                  width: 100%;
                }
                .notVinello {
                }
                .notSmartbox {
                  width: 100%;
                }
              }
            }
            .nomeVino {
              padding: 15px;
              .set-font-latoLight(@size: 18px);
            }
            .quantity {
              padding: 5px;
              .set-font-latoRegular(@size: 16px);
              .quantità {
              }
            }
            .price1 {
              padding: 10px;
              .set-font-latoRegular(@size: 16px; @color: light-green);
            }
            .price {
              padding: 10px;
              .set-font-latoRegular(@size: 16px; @color: light-green);
            }
            .remove {
              .logo {
                width: 15px;
              }
            }
          }
        }
      }
      .subtoto {
        margin-left: 65%;
        .set-font(@size: 18px, @weight: bold)
      }
      .botton {
        margin-left: 65%;
        margin-top: 10px;
        margin-bottom: 30px;
        .set-font()
      }
    }

  }

  @media (min-width: 1025px) and (max-width: 1366px) {
    #carrello {
      .detailcar {
        #car {
          .set-font-latoLight();
        }
        .numprod {
        }
      }
      .categoria {
        .set-font-title(@size: 22px);
      }
      .testoRiepilogo {
        .set-font();
        #dettaglio {
          .righeRiepilogo {
            .carlink {
              #imgVino {
                .vinello {
                  width: 55%;
                }
              }
            }
            .nomeVino {
              .set-font-latoLight(@size: 22px);
            }
            .quantity {
              padding: 15px;
              .set-font-latoRegular(@size: 20px);
              .quantità {
              }
            }
            .price1 {
              .set-font-latoRegular(@size: 20px; @color: light-green);
            }
            .price {
              .set-font-latoRegular(@size: 20px; @color: light-green);
            }
            .remove {
              .logo {
                width: 20px;
              }
            }
          }
        }
      }
      .subtoto {
        margin-left: 75%;
        margin-top: 50px;
        letter-spacing: 1px;
        .set-font(@size: 22px, @weight: bold)
      }
      .botton {
        width: 165px;
        background-color: @myOrange;
        border-color: @borderOrange;
        text-align: center;
        letter-spacing: 1px;
        margin-left: 80%;
        margin-top: 50px;
        margin-bottom: 50px;
        .set-font()
      }
    }

  }
</style>



// WEBPACK FOOTER //
// src/components/Carrello.vue